import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const LinkedImageIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 20 20"
      sx={{
        width: '13.89px',
        height: '13.89px',
        position: 'relative',
        top: '1.39px',
        left: '1.39px',
        ...sx,
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1665 5.8335H10.8332V7.50016H14.1665C15.5415 7.50016 16.6665 8.62516 16.6665 10.0002C16.6665 11.3752 15.5415 12.5002 14.1665 12.5002H10.8332V14.1668H14.1665C16.4665 14.1668 18.3332 12.3002 18.3332 10.0002C18.3332 7.70016 16.4665 5.8335 14.1665 5.8335ZM9.1665 12.5002H5.83317C4.45817 12.5002 3.33317 11.3752 3.33317 10.0002C3.33317 8.62516 4.45817 7.50016 5.83317 7.50016H9.1665V5.8335H5.83317C3.53317 5.8335 1.6665 7.70016 1.6665 10.0002C1.6665 12.3002 3.53317 14.1668 5.83317 14.1668H9.1665V12.5002ZM6.6665 9.16683H13.3332V10.8335H6.6665V9.16683Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default LinkedImageIcon;
